import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { STATUS } from 'constants/miscConstants';
import AdminService from 'services/AdminService';

const { SUCCESS, ERROR } = STATUS;

export const initialState = {
  loading: false,
  message: '',
  showMessage: false,
  status: SUCCESS,
  jobStats: {},
  jobsDetailsLoading: false,
  data: {},
  filters: {
    pageNumber: 1,
    pageSize: 10,
  },
};

export const getJobStats = createAsyncThunk('jobsApplication/getJobStats', async (_, { rejectWithValue }) => {
  try {
    const response = await AdminService.getJobStats();
    return response;
  } catch (err) {
    return rejectWithValue(err?.message || 'Something went wrong');
  }
});

export const getJobsDetails = createAsyncThunk('jobsApplication/getJobsDetails', async (data, { rejectWithValue }) => {
  const { filters, pageNumber, pageSize } = data;
  try {
    const response = await AdminService.getJobsDetails({ filters });
    return { response, pageNumber, pageSize };
  } catch (err) {
    return rejectWithValue(err?.message || 'Something went wrong');
  }
});

export const jobsApplicationSlice = createSlice({
  name: 'jobsApplication',
  initialState,
  reducers: {
    hideMessage: (state) => {
      state.message = '';
      state.status = SUCCESS;
      state.showMessage = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getJobStats.pending, (state) => {
        state.loading = true;
      })
      .addCase(getJobStats.fulfilled, (state, action) => {
        state.jobStats = action.payload;
        state.loading = false;
      })
      .addCase(getJobStats.rejected, (state, action) => {
        state.loading = false;
        state.status = ERROR;
        state.message = action.payload;
        state.showMessage = true;
      })

      .addCase(getJobsDetails.pending, (state) => {
        state.jobsDetailsLoading = true;
      })
      .addCase(getJobsDetails.fulfilled, (state, action) => {
        const { response, pageNumber, pageSize } = action.payload;
        state.filters.pageNumber = pageNumber;
        state.filters.pageSize = pageSize;
        state.data = response;
        state.jobsDetailsLoading = false;
      })
      .addCase(getJobsDetails.rejected, (state, action) => {
        state.jobsDetailsLoading = false;
        state.status = ERROR;
        state.message = action.payload;
        state.showMessage = true;
      });
  },
});

export const { hideMessage } = jobsApplicationSlice.actions;

export default jobsApplicationSlice.reducer;
